import { useEffect, useState } from "react";
import TagManager from "react-gtm-module";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "./App.css";
import { ThemeContext } from "./contexts";
import Page from "./Page";

function App() {
  const [darkMode, setDarkMode] = useState(() => {
    const savedMode = localStorage.getItem("darkMode");
    return savedMode === "true" ? true : false;
  });

  useEffect(() => {
    localStorage.setItem("darkMode", darkMode);
  }, [darkMode]);

  useEffect(() => {
    TagManager.initialize({ gtmId: "GTM-NFMZK5LC" }); // GTM
  }, []);

  return (
    <>
      <ThemeContext.Provider value={{ darkMode, setDarkMode }}>
        <Page />
        <ToastContainer />
      </ThemeContext.Provider>
    </>
  );
}

export default App;
